import { ConnectorType } from "@/entities/DataAssociation/File.model";
import { QuickbooksIcon } from "./connectors/QuickbooksIcon";
import { ShareIcon } from "@heroicons/react/24/outline";
import { XeroIcon } from "./connectors/XeroIcon";
import { NetSuiteIcon } from "./connectors/NetSuiteIcon";

export const ConnectorIcon = ({
    connectorType,
    condensed = false,
    large = false,
}: {
    condensed?: boolean;
    connectorType: ConnectorType;
    large?: boolean;
}) => {
    switch (connectorType) {
        case ConnectorType.QUICKBOOKS:
            return <QuickbooksIcon condensed={condensed} large={large} />;
        case ConnectorType.QUICKBOOKS_DESKTOP:
            return <QuickbooksIcon condensed={condensed} large={large} />;
        case ConnectorType.QUICKBOOKS_SANDBOX:
            return <QuickbooksIcon condensed={condensed} large={large} />;
        case ConnectorType.XERO:
            return <XeroIcon condensed={condensed} large={large} />;
        case ConnectorType.NETSUITE:
            return <NetSuiteIcon condensed={condensed} large={large} />;
        default:
            return <ShareIcon width={16} />;
    }
};
